// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uSnD","largestCol":"styles_largestCol__M5exP","smallestCol":"styles_smallestCol__FFedI"};